module.exports = __webpack_public_path__ + "img/pic_warnings.1775439203884.png";